
import { RequireAuth } from "../../fabrix/components/authentication/auth-validation";
import { ModuleInfo } from "../../fabrix/types";
import { icons } from "./icons";
import translationJson from "./translations.json";

const moduleRoutes = (): ModuleInfo => {
  return {
    path: "/notifications/",
    label: "NOTIFICATIONS",
    name: "notifications",
    id: "da92446b-b546-4500-9f3a-6894b14c0e89",
    lazy: async () => {
      const Page = (await import("./")).default;
      return {
        element: (
          <RequireAuth roles={[]}>
            <Page />
          </RequireAuth>
        ),
      };
    },
    translations: translationJson,
    icons: icons,
    children: [
      {
        path: "/notifications/",
        label: "HOME",
        name: "home",
        id: "f19bd904-e2ae-479a-a9fc-35acf33486d3",

        lazy: async () => {
          const Page = (await import("./routes/home")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
    ],
  };
};

export default moduleRoutes;
